module.exports = __webpack_public_path__ + "img/al-hilal-bank.842e0f15.jpg";